/** Categories */

/** Surveys */
const initialSurveyState = {
	apiEndpoint: '/surveymanagement/survey',
	loading: false,
	docType: null,
	surveys: [],
	currentSurvey: {
		status: 'draft',
		current_version: {
			version: '1.0',
		},
		new_version: '1.0',
		private: false,
		anonymous: false,
		multiple: false,
		user_has_submitted: false
	},
	surveyVersions: [],
	surveySubmissions: [],
	loadingSurveyVersions: false,
	user_filter: false,
	filters: {
		categories: [],
		searchQuery: '',
		status: 'approved',
	},
	sortBy: {
		field:'created_time',
		direction: 'DESC'
	},
	tabFilter: 'approved',
	favourites: [],
	current_version: null,
	pagination: {
		total: 10,
		per_page: 10,
		current_page: 1,
		last_page: 1,
		from: 1,
		to: 10,
	},
}

const surveyState = JSON.parse(JSON.stringify(initialSurveyState))

export { initialSurveyState, surveyState }
